<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('dues.Header') }}</h2>
            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <div id="gridDues">
                <kendo-datasource ref="datasourceDues"
                                  :transport-read-url="url"
                                  :transport-read-data-type="'jsonp'">
                </kendo-datasource>
                <kendo-grid :data-source-ref="'datasourceDues'"
                            :toolbar="['pdf']"
                            :mobile="true"
                            :pdf-all-pages="true"
                            :pdf-avoid-links="true"
                            :pdf-paper-size="'A4'"
                            :pdf-margin="{ top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' }"
                            :pdf-landscape="true"
                            :pdf-repeat-headers="true"
                            :pdf-file-name="$t('dues.Header')"
                            :pdf-title="$t('dues.Header')"
                            :pdf-scale="0.8">
                    <kendo-grid-column :field="'Vertragsart'"
                                       :title="$t('dues.GridColumnHeaderContracttype')"></kendo-grid-column> 
                    <kendo-grid-column :field="'Beitrag'"
                                       :title="$t('dues.GridColumnHeaderDues')"></kendo-grid-column> 
                    </kendo-grid>
            </div>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <ul>
                    <li>{{ $t('dues.Note1') }}</li>
                    <li>{{ $t('dues.Note2') }}</li>
                    <li>{{ $t('dues.Note3') }}</li>
                    <li>{{ $t('dues.Note4') }}</li>
                    <li>{{ $t('dues.Note5') }}</li>
                </ul>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/classes/eventBus.js';
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import kendo from '@progress/kendo-ui';
    import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
    import { KendoDataSource } from '@progress/kendo-datasource-vue-wrapper';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-grid': Grid,
            'kendo-grid-column': GridColumn,
            'kendo-datasource': KendoDataSource
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                config: config,
                theImage: '',
                schemaModelFields: {
                    Vertragsart: { validation: { required: true } },
                    Beitrag: { validation: { required: true } }
                }
            }
        },
        computed: {
        },
        mounted() {
            window.$ = kendo.jQuery;
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        created() {
            this.url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Vertragsarten"
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>